import * as FCFS from '../constants/fcfs';

export default {
  /**
   * Get the queue list state.
   *
   * @param state
   * @returns {Array}
   */
  [FCFS.GET_QUEUE_LIST]: (state) => {
    return state.queues;
  },

  /**
   * Get the last queue state.
   * @param state
   * @returns {number}
   */
  [FCFS.GET_LAST_QUEUE]: (state) => {
    return state.last_queue;
  }
}


// WEBPACK FOOTER //
// ./src/store/fcfs/getters.js